import React from 'react'
import SplitHero from '../../SplitHero'

class Slide extends React.PureComponent {
  // `onClick` and `onMouseDown` are used to allow mouse-dragging of the
  // carousel, without triggering the href of the anchor.

  constructor() {
    super()
    this._handleMouseDown = this._handleMouseDown.bind(this)
    this._handleClick = this._handleClick.bind(this)
  }

  _handleMouseDown(e) {
    // store mouse position when click starts
    this.x = e.screenX
  }

  _handleClick(e) {
    const delta = Math.abs(e.screenX - this.x)
    if (delta > 10) {
      // If mouse moved more than threshold, ignore the click event
      e.preventDefault()
    }
    this.x = 0
  }

  render() {
    return (
      <SplitHero
        {...this.props}
        onMouseDown={this._handleMouseDown}
        onClick={this._handleClick}
      />
    )
  }
}

export default Slide
